<script lang="ts">
  // Stripe Live mode requires these legal links on every route.
  import { resolve } from '$app/paths';
  import { t } from '$lib/i18n';
  import { UiKeys } from '@voicedojo/backend-types';
</script>

<footer class="site-footer no-print">
  <nav aria-label={t(UiKeys.Footer.LegalAria)}>
    <a href={resolve('/terms')}>{t(UiKeys.Footer.Terms)}</a>
    <a href={resolve('/privacy')}>{t(UiKeys.Footer.Privacy)}</a>
    <a href={resolve('/legal/third-party')}>{t(UiKeys.Footer.ThirdParty)}</a>
    <a href={resolve('/pricing')}>{t(UiKeys.Footer.Pricing)}</a>
    <a href={resolve('/about')}>{t(UiKeys.Footer.About)}</a>
    <a href={resolve('/support')} data-testid="support-link">{t(UiKeys.Footer.Support)}</a>
  </nav>
  <span>{t(UiKeys.Footer.Copyright)}</span>
</footer>

<style lang="scss">
  .site-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.5rem 1.5rem;
    border-top: 1px solid var(--line);
    background: var(--paper);
    padding: 1rem;
    color: var(--ink-soft);
    font-family: var(--font-ui);
    font-size: var(--text-body);
  }

  nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.5rem 1.5rem;
  }

  nav a {
    display: inline-flex;
    align-items: center;
    min-height: 1.5rem;
    color: var(--accent-text);
    text-decoration: none;
  }

  nav a:hover {
    text-decoration: underline;
  }
</style>
